import { render } from "./ProductBillingPeriodsTable.vue?vue&type=template&id=024a7a20"
import script from "./ProductBillingPeriodsTable.vue?vue&type=script&lang=js"
export * from "./ProductBillingPeriodsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__